// src/app/core/shared/year.store.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class YearStore {
    // Define global bounds for the app
    private static readonly MIN_YEAR = 2019;
    private static readonly MAX_YEAR = 2045;

    // Default selected year = MAX (2045)
    private readonly yearSubject = new BehaviorSubject<number>(YearStore.MAX_YEAR);
    readonly year$ = this.yearSubject.asObservable();

    // Default display range start (min) = 2019
    displayMinYear$ = new BehaviorSubject<number>(YearStore.MIN_YEAR);

    setYear(y: number) {
        const ny = Math.round(Number.isFinite(y) ? y : YearStore.MAX_YEAR);
        const clamped = Math.min(YearStore.MAX_YEAR, Math.max(YearStore.MIN_YEAR, ny));
        this.yearSubject.next(clamped);
    }

    setDisplayMinYear(min: number) {
        const curSelected = this.getYear();
        const nmin = Math.round(Number.isFinite(min) ? min : YearStore.MIN_YEAR);
        // Clamp to [MIN_YEAR, current selected year]
        const clamped = Math.min(curSelected, Math.max(YearStore.MIN_YEAR, nmin));
        this.displayMinYear$.next(clamped);
    }

    getYear(): number {
        return this.yearSubject.value;
    }

    // Optional helpers if needed by UI
    getMin(): number { return YearStore.MIN_YEAR; }
    getMax(): number { return YearStore.MAX_YEAR; }
}